import React from 'react';
import { Row, Col } from 'react-bootstrap';

export default function AcctownerSettings() {

    return (
        <div>
            <Row className="ml-0 mr-0 page-head-row page-head-row-big align-items-center trans-listing-head">
                <Col>
                    <h4 className="title-med mt-0 pt-1">Settings</h4>
                </Col>
            </Row>
        </div>
    );

};